module.exports = __webpack_public_path__ + "img/collection-weddingRingsStylesElegant@2x.cf16d27.jpg";